import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';

const steps = [
  {
    index: 0,
    label: 'Hydrogen (H₂)',
    description: `Green hydrogen powers fuel cells for vehicles, can be stored, or 
    blended with natural gas pipelines.`,
  },
  {
    index: 1,
    label: 'Green Ammonia (NH₃)',
    description:
      'Produced from green hydrogen and nitrogen, it’s easier to transport and store, making it ideal for shipping and energy storage.',
  },
  {
    index: 2,
    label: 'Green Methanol (CH₃OH)',
    description: `Made from captured CO₂ and green hydrogen, it works with existing engines and fuel cells, enabling a gradual shift to cleaner fuels.`,
  },
];

export default function VerticalLinearStepper() {
  
    return (
      <div className='my-8 md:my-12 lg:my-16 mx-8 sm:mx-16 md:mx-28 lg:mx-36'>
          <Box sx={{ maxWidth: 1200 }}>
          <Stepper 
            activeStep={steps.length}    // Set active step to the length of steps array
            orientation="vertical"
            sx={{
                '& .MuiStepIcon-root': {
                    width: { xs: '40px', sm: '50px', md: '60px', lg: '80px' },
                    height: { xs: '40px', sm: '50px', md: '60px', lg: '80px' },
                    color: '#589197',
                    '&.Mui-active': { // Ensure active steps also use the correct color
                      color: '#589197', 
                    },
                    '&.Mui-completed': { // You can also adjust the completed icon color
                      color: '#589197',
                    },
                },
                '& .MuiStepConnector-line': {
                    minHeight: { xs: '20px', sm: '25px', md: '30px', lg: '40px' },
                    marginLeft: { xs: '20px', sm: '25px', md: '30px', lg: '40px' }
                },
                '& .MuiStep-root': {
                    paddingBottom: '2px'
                },
                '& .MuiStepConnector-root': {
                    marginLeft: 0,
                }, 
                '& .MuiStepLabel-iconContainer': {
                    marginRight: { xs: '20px', sm: '25px', md: '30px', lg: '40px' },
                },
                // Add label styles
                '& .MuiStepLabel-label': {
                    fontSize: { xs: '1rem', sm: '1.25rem', md: '1.5rem', lg: '1.75rem' },
                    fontWeight: 500,
                    marginBottom: { xs: '4px', sm: '6px', md: '8px', lg: '10px' }
                },
                // Add description
                '& .MuiTypography-root': {
                    fontSize: { xs: '0.875rem', sm: '1rem', md: '1.125rem', lg: '1.25rem' },
                    color: 'text.secondary'
                }
            }}
          >
              {steps.map((step, index) => (
              <Step key={step.label}>
                  <StepLabel>
                    {step.label}
                    <Typography>{step.description}</Typography>
                  </StepLabel>            
              </Step>
              ))}
          </Stepper>
          </Box>
      </div>
    );
  }